import request from '@/utils/request'

export function hospUserLogin(data) {
  return request({
    url: '/api/system/hosp-login',
    method: 'post',
    data
  })
}


export function getAcctInfo() {
  return request({
    url: '/api/system/acct-info',
    method: 'get'
  })
}

export function getAcctMenus() {
  return request({
    url: '/api/system/acct-menus',
    method: 'get',
  })
}


export function adminLogin(data) {
  return request({
    url: '/api/system/admin-login',
    method: 'post',
    data
  })
}

export function imgVerify(data) {
  return request({
    url: '/api/system/img-verify',
    method: 'post',
    data:data,
  })
}



